import { array, object, string } from "yup"
import { ALL_COUNTRIES, USA_COUNTRY_CODE } from "../../util/country"
import { isNilOrEmpty } from "../../util/string"
import { ZIP_CODE } from "../regex/constants"
import { buildSchema } from "./util/build-schema"

const isDomestic = (country: string) => USA_COUNTRY_CODE === country

const stateRegionSchema = string().when(
  ["availableSubdivisions"],
  ([availableSubdivisions], fieldSchema) => {
    if (isNilOrEmpty(availableSubdivisions)) {
      return fieldSchema.optional()
    }
    return fieldSchema.required().test(
      // Helps ensure leftover values on country switches are validated
      "isOneOfAvailableSubdivisions",
      "yup.common.mixed.required",
      (value) =>
        availableSubdivisions.some(
          (subdivision: { value: string; label: string }) =>
            subdivision.value === value
        )
    )
  }
)

const schema = object({
  city: string().required(),
  country: string().required().oneOf(Array.from(ALL_COUNTRIES)),
  postalCode: string().when("country", {
    is: isDomestic,
    then: (fieldSchema) =>
      fieldSchema
        .required()
        .matches(ZIP_CODE, { message: "yup.address.postalCode" }),
    otherwise: (fieldSchema) => fieldSchema.nullable(),
  }),
  availableSubdivisions: array()
    .of(object({ value: string(), label: string() }))
    .default([]), // This field is updated after GET /zero-hash-subdivisions is called
  stateRegion: stateRegionSchema,
  streetOne: string().trim().required(),
  streetTwo: string().trim().nullable(),
})

export const addressSchema = buildSchema("Address", schema)
